import type { FC, ReactElement } from 'react';

import { useGameConfig } from '../../config/GameConfigProvider';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { Modal } from '../modal/modal';

export const BetLimitModalConnected: FC = (): ReactElement => {
  const dispatch = useCoreDispatch();
  const { betLimitContent } = useGameConfig();

  const open = useHeaderSlice.getCoreBetLimitsOpen();
  const heightAdjustment = useConfigSlice.playAreaDimensions()?.height;

  return (
    <Modal
      data-testid="bet-limits-modal"
      draggable
      fullScreenNoClose
      heightAdjustment={heightAdjustment}
      onClose={() => dispatch(headerActions.setBetLimitsOpen(!open))}
      open={open}
      placement="start"
      tk="MENU_PAYOUTS_LIMITS"
    >
      {betLimitContent}
    </Modal>
  );
};
